/**
 * Generated by "@vuepress/internal-root-mixins"
 */
import m0 from "/Users/i071496/Dev/Repos/github/v-calendar/node_modules/@vuepress/core/lib/client/root-mixins/updateMeta.js"
import m1 from "/Users/i071496/Dev/Repos/github/v-calendar/node_modules/@vuepress/plugin-active-header-links/clientRootMixin.js"
import m2 from "/Users/i071496/Dev/Repos/github/v-calendar/node_modules/@vuepress/plugin-nprogress/clientRootMixin.js"

export default [
  m0,
  m1,
  m2
]